import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getMachineTransfers: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].GET_TRANSFERS,
	},
	createMachineTransfer: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].CREATE_TRANSFER,
	},
	getMachineTransfer: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].GET_TRANSFER,
	},
	patchMachineTransfer: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].PATCH_TRANSFER,
	},
	putMachineTransfer: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].PUT_TRANSFER,
	},
	deleteMachineTransfer: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].DELETE_TRANSFER,
	},
}